import { require200Status } from "../../utils/response.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function gamesEndpoints(builder) {
  return {
    getGameList: builder.query({
      providesTags: ["games"],
      query: ({ query }) => ({
        url: `/member/game/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    }),
    getGameGateway: builder.query({
      providesTags: ["games", "game-providers"],
      query: ({ query }) => ({
        url: `/member/game/gateway${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    }),
    getGameProviderList: builder.query({
      providesTags: ["game-providers"],
      query: ({ query }) => ({
        url: `/member/game/providers${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    }),
    getGameProviderStats: builder.query({
      providesTags: ["game-providers"],
      query: () => ({
        url: `/member/game/stats`,
        method: "GET",
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec()
    }),
    getGameCategoryList: builder.query({
      providesTags: ["game-categories"],
      query: ({ query }) => ({
        url: `/member/category/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    }),
    getGameRecentList: builder.query({
      providesTags: ["game-recent"],
      query: ({ query }) => ({
        url: `/member/game/recent${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  gamesEndpoints as default
};
